(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.mobileMenu = {
    attach: function (context, settings) {
      const header = $('.global-header', context);
      const trigger = $('.global-header .mobile-menu-trigger', context);
      $(trigger).click(function () {
        if (header.hasClass('mobile-menu--active')) {
          $(header).removeClass('mobile-menu--active');
        } else {
          $(header).addClass('mobile-menu--active');
        }
      });
    }
  };
})(window.Drupal, window.jQuery);
